<template>
    <div id="todo-app" class="performance_app border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

        <vue-headful :title="$t('my-performance')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">

            <!-- ФИЛЬТРЫ -->
            <ListFilters :sidebarToggle="toggleSidebar" :requiredFilter="requiredFilter" :itemHandler="infiniteHandle" />

        </vs-sidebar>
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <!-- header -->
            <div class="head__actions flex items-center flex-wrap justify-between">
                <feather-icon class="cursor-pointer emc_mobile_sidebar md:inline-flex lg:hidden ml-4 mr-4" icon="MenuIcon" @click.stop="toggleSidebar(true)" />
            </div>

            <!-- список -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                @ps-y-reach-end="infiniteHandle"
                :key="$vs.rtl">

                    <ul v-if="list.length">
                        <li
                            class="todo_todo-item cursor-pointer"
                            @click="openListItem(item)"
                            v-for="(item, index) in list"
                            :key="`d_${index}`"
                            :style="[{transitionDelay: (index * 0.1) + 's'}]">

                                <ListItem :item="item" />

                        </li>
                    </ul>

                    <!-- Выводим сообщение если данных нет -->
                    <div class="mt-4 ml-5 mr-5" v-if="emptyMessage">
                        <vs-alert active="true">
                            {{$t('no_data_text')}}
                        </vs-alert>
                    </div>

                    <!-- В этот див выводил лоадер -->
                    <div id="infinite_loader" class="vs-con-loading__container"></div>
            </component>
        </div>
    </div>
</template>

<script>
import perfomance from '@/store/modules/perfomance.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ListFilters from './ListFilters.vue'
import ListItem from './ListItem.vue'
import ItemView from './ItemView.vue'
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            id:null,//это для desktop widget myperfomence id передет
            isViewSidebarActive: false,
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            activeItem: null,
            requiredFilter: ['study_year'],
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            }
        }
    },
    components: {
        VuePerfectScrollbar,
        ListFilters,
        ListItem,
        ItemView
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        ...mapState({
            list: state => state.perfomance.list
        }),
        page: {
            get() {
                return this.$store.state.perfomance.page
            },
            set(value) {
                this.$store.commit("perfomance/SET_PAGE", value)
            }
        },
        infiniteStatus: {
            get() {
                return this.$store.state.perfomance.infiniteStatus
            },
            set(value) {
                this.$store.commit('perfomance/SET_INF_STATUS', value)
            }
        },
        windowWidth() { return this.$store.state.windowWidth },
        user() {
            return this.$store.state.user.user
        },
    },

    mounted() {
        if(this.id){
            this.$vs.loading();
            setTimeout(()=>{
                this.list.forEach(element => {
                    if(element.disc_uid == this.id){
                        this.openListItem(element)
                        this.$vs.loading.close()
                    }
                });
            },2000)
            this.$vs.loading.close()
        }
    },
    created: function() {
        // Регистрируем стор
        if(!this.$store.hasModule('perfomance'))
            this.$store.registerModule('perfomance', perfomance)
        this.setSidebarWidth()

        if(this.$route.query.id){
            this.id  = this.$route.query.id;
            this.$router.replace({'query': null});

        }


    },
    beforeDestroy () {
        // Если покидаем текущий компонент(кроме child), то удаляем стор
        if (this.$route.name !== 'my-performance-detail'){
            this.$store.unregisterModule('perfomance')
        }
    },
    methods: {
        ...mapActions({
            fetchList: 'perfomance/fetchList',
        }),
        async openListItem(item) {
            // Получаем таблицу выбранной дисциплины
            await this.$router.push({name:'my-performance-detail',query: {uid: item.discipline.uid, name: item.discipline.name }})
        },
        infiniteHandle({update = false}) {
            // Если update = true запрашиваем список заного с новыми параметрами
            if(update) {
                this.infiniteStatus = true
                this.page = 0
                this.emptyMessage = false
            }
            // Запрашиваем список
            this.listHandler()
        },
        async listHandler() {
            // Получаем список дисциплин, проверяем статус бесконечной загрузки, есть true и loading = false то пропускаем
            if(!this.loading && this.infiniteStatus) {
                this.loading = true
                this.emptyMessage = false
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })
                try {
                    this.page = this.page+1
                    const res = await this.fetchList({
                        page: this.page,
                        route: this.$route,
                        profile:this.user.profileId
                    })

                    // Если на первой странице данных нет вообще, выводим сообщение
                    if(!res || this.page === 1 && !res.results.length) this.emptyMessage = true
                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if(!res || !res.next) this.infiniteStatus = false
                } catch({detail}) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger',
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close('#infinite_loader > .con-vs-loading')
                }
            }
        },
        toggleSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        }
    }
}
</script>

<style scoped lang="scss">
.tr_label{
    background: transparent!important;
    td{
        text-align: center;
    }
}
.isc_info{
    .item{
        &:not(:last-child){
            margin-bottom: 13px;
            padding-bottom: 13px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        .label{
            font-weight: bold;
            padding-right: 10px;
            min-width: 250px;
        }
    }
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
@media only screen and (min-width: 993px) {
    .performance_app{
        .vs-sidebar-position-right{
            max-width: calc(100% - 260px)!important;
        }
    }
}
.filters_scroll_area{
    position: relative;
    width: 100%;
    margin: auto;
    height: 100%;
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    height: 100%;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
